import { Link } from "react-router-dom";

const renderPageNumbers = (
  totalPages: number,
  pageIndex: number,
  setPageIndex: any
) => {
  const pages = [];
  const maxVisiblePages = 5;

  if (totalPages <= maxVisiblePages) {
    for (let i = 0; i < totalPages; i++) {
      pages.push(
        <li key={i} className="page-item">
          <Link
            to="#"
            className={pageIndex === i ? "page-link active" : "page-link"}
            onClick={() => setPageIndex(i)}
          >
            {i + 1}
          </Link>
        </li>
      );
    }
  } else {
    pages.push(
      <li key={0} className="page-item">
        <Link
          to="#"
          className={pageIndex === 0 ? "page-link active" : "page-link"}
          onClick={() => setPageIndex(0)}
        >
          1
        </Link>
      </li>
    );

    if (pageIndex > 3) {
      pages.push(
        <li key="dots-start" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    const startPage = Math.max(1, pageIndex - 2);
    const endPage = Math.min(totalPages - 2, pageIndex + 2);

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li key={i} className="page-item">
          <Link
            to="#"
            className={pageIndex === i ? "page-link active" : "page-link"}
            onClick={() => setPageIndex(i)}
          >
            {i + 1}
          </Link>
        </li>
      );
    }

    if (pageIndex < totalPages - 4) {
      pages.push(
        <li key="dots-end" className="page-item disabled">
          <span className="page-link">...</span>
        </li>
      );
    }

    pages.push(
      <li key={totalPages - 1} className="page-item">
        <Link
          to="#"
          className={
            pageIndex === totalPages - 1 ? "page-link active" : "page-link"
          }
          onClick={() => setPageIndex(totalPages - 1)}
        >
          {totalPages}
        </Link>
      </li>
    );
  }

  return pages;
};

export default renderPageNumbers;
